import { FC, useEffect, useState } from 'react'
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { ChatContent } from '../../../layouts/ChatContent'

import {ChatBase} from '../../chat/ChatBase'

import { LayoutProvider } from '../../../context/layout';

import { authAPI } from '../../../api'
import { useChat } from '../../../context/chat/Context'
import { setCurrentChat, setChats } from '../../../context/chat'

import { Modal } from '../../../components/Modal';

import toastr from 'toastr';

import { MarkdownWithLinks } from '../../../components/MarkdownWithLinks';

interface StartNewChatModelProps {
  show: boolean;
  handleNewChat: () => void;
  handleClose: () => void;
}

const StartNewChatModel: FC<StartNewChatModelProps> = ({show, handleNewChat, handleClose}) => {
  const intl = useIntl()
  return (
    <>
      <Modal
        show={show}
        handleClose={handleClose}
        dialogClassName="modal-sm"
      >
        <div className="text-center">
          <p className="fs-5"><MarkdownWithLinks>{intl.formatMessage({ id: "chat.start_new_guest_chat.description" })}</MarkdownWithLinks></p>
          <div className="d-flex flex-column">
            <button
              className="btn btn-secondary mb-2"
              onClick={handleNewChat}
            >
              {intl.formatMessage({ id: "chat.start_new_guest_chat.button" })}
            </button>
            <Link className="btn btn-primary" to="/a/sign-in">
              {intl.formatMessage({id: 'user.sign_in'})}
            </Link>
          </div>
        </div>
      </Modal>
    </>
  )
}

const GuestChatBase = () => {
  const { dispatch } = useChat()

  const [startNewChatModal, setStartNewChatModal] = useState(false)

  const intl = useIntl()

  useEffect(() => {
    const handleHashChange = async () => {
      if( window.location.hash.replace('#', '') === 'expired' ) {
        toastr.info(intl.formatMessage({id: `chat.guest_chat_session_expired`}))
        await startNewChat()
        window.history.replaceState(null, '', window.location.pathname)
      }
    };

    window.addEventListener('hashchange', handleHashChange);

    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  const startNewChat = async () => {
    try {
      const { data: session } = await authAPI.getGuestSession()
      dispatch(setChats([{"id":session["data"]["chat_id"]}]))
      dispatch(setCurrentChat(session["data"]["chat_id"]))
    } catch (error) {
      console.error("Guest session error:", error)
    }
  }

  const confirmStartNewChat = () => {
    const chatMessages = document.querySelectorAll('.chat-message');
    if (chatMessages.length > 0) {
      setStartNewChatModal(true);
    }
  }

  return (
    <LayoutProvider>
      <ChatContent handleStartNewChat={confirmStartNewChat}>
        <ChatBase handleStartNewChat={confirmStartNewChat}/>
        <StartNewChatModel
          show={startNewChatModal}
          handleNewChat={() => {
            startNewChat()
            setStartNewChatModal(false)
          }}
          handleClose={() => setStartNewChatModal(false)}
        />
      </ChatContent>
    </LayoutProvider>
  )
}

export {GuestChatBase}
